import { useEffect, useRef } from "react";
import MessageBubble from "./MessageBubble";

export default function MessageList({ messages, error }) {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages]);

  return (
    <div className="ai-msglist">
      {messages.map((m, i) => (
        <MessageBubble key={m.id || i} message={m} />
      ))}
      {error ? <div className="ai-error-banner">{error}</div> : null}
      <div ref={endRef} />
    </div>
  );
}
